import Vue from 'vue';
import Vuex from 'vuex';
import * as Mutations from './root-mutations';

import { RegistrationModule } from './modules/registration/registration.module';
import { NotificationsModule } from './modules/notifications/notifications.module';
import { ModalModule } from './modules/modal/modal.module';
import { SpinnerModule } from './modules/spinner/spinner.module';
import { LoginModule } from './modules/login/login.module';
import { TeachersModule } from './modules/teachers/teachers.module';
import { ConfirmModule } from './modules/confirm/confirm.module';
import { PageModule } from './modules/page/page.module';
import { SelectModule } from './modules/select/select.module';
import { TShirtsModule } from './modules/t-shirts/t-shirts.module';
import { PickupOptionsModule } from './modules/pickup-options/pickup-options.module';
import { LocationsModule } from './modules/locations/locations.module';
import { SMSTrackingModule } from './modules/sms-tracking/sms-tracking.module';
import { UsersModule } from './modules/users/users.module';
import { EmailTrackingModule } from './modules/email-tracking/email-tracking.module';
import { BillingInfoModule } from './modules/billing-info/billing.module';
import { ClassFormModule } from './modules/class-form/class-form.module';
import { ClassPageModule } from './modules/class-page/class-page.module';
import { StatsModule } from './modules/stats/stats.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { CouponsModule } from './modules/coupons/coupons.module';
import { TransactionsModule } from './modules/transactions/transactions.module';
import { MobileModule } from './modules/mobile/mobile.module';
import { ActivityCalendarModule } from './modules/activity-calendar/activity-calendar.module';
import { CampFormModule } from './modules/camp-form/camp-form.module';
import { CampPageModule } from './modules/camp-page/camp-page.module';
import { ResetPasswordModule } from './modules/reset-password/reset-password.module';
import { InvoicesModule } from './modules/invoices/invoices.module';
import { ActivityChildrenModule } from './modules/activity-children-list/activity-children.module';
import { AttendanceModule } from './modules/attendance/attendance.module';
import { ParentsModule } from './modules/parents/parents.module';
import { HeaderModule } from './modules/header/header.module';
import { AccessListModule } from './modules/access-list/access-list.module';
import { TextareaModal } from './modules/textarea-modal/textarea-modal.module';
import { ChildrenModule } from './modules/children/children.module';
import { ProfileModule } from './modules/profile/profile.module';
import { PopupModule } from './modules/popup/popup.module';
import { AftercarePageModule } from './modules/aftercare-page/aftercare-page.module';
import { AftercareFormModule } from './modules/aftercare-form/aftercare-form.module';
import { SubscriptionsModule } from './modules/subscriptions/subscriptions.module';
import { CustomFormsModule } from './modules/custom-forms/custom-forms.module';
import { PayNowModule } from './modules/pay-now/pay-now.module';

import { CheckDevicePlugin } from './plugins/check-device.plugin';
import { LocalStoragePlugin } from './plugins/local-storage.plugin';
import { InitialStatePlugin, getInitialState } from './plugins/InitialStatePlugin';
import { UsernameSessionStoragePlugin } from './plugins/username-session-storage.plugin';
import { SchoolInfoPlugin } from './plugins/school-info.plugin';


Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        RegistrationModule,
        NotificationsModule,
        ModalModule,
        SpinnerModule,
        LoginModule,
        TeachersModule,
        ConfirmModule,
        PageModule,
        SelectModule,
        TShirtsModule,
        PickupOptionsModule,
        LocationsModule,
        UsersModule,
        SMSTrackingModule,
        BillingInfoModule,
        ClassFormModule,
        ClassPageModule,
        StatsModule,
        DashboardModule,
        CouponsModule,
        TransactionsModule,
        MobileModule,
        ActivityCalendarModule,
        CampFormModule,
        CampPageModule,
        ResetPasswordModule,
        InvoicesModule,
        ActivityChildrenModule,
        AttendanceModule,
        HeaderModule,
        AccessListModule,
        TextareaModal,
        ParentsModule,
        ChildrenModule,
        ProfileModule,
        PopupModule,
        AftercarePageModule,
        AftercareFormModule,
        SubscriptionsModule,
        CustomFormsModule,
        EmailTrackingModule,
        PayNowModule
    },

    plugins: [
        LocalStoragePlugin,
        CheckDevicePlugin,
        UsernameSessionStoragePlugin,
        InitialStatePlugin,
        SchoolInfoPlugin
    ],

    state: {
        isMobile: false
    },

    getters: {
        isMobile: state => state.isMobile
    },

    mutations: {
        [Mutations.RESET_STATE](state) {
            const initialState = getInitialState();
            Object.keys(initialState)
                .forEach(key => state[key] = initialState[key]);
        },

        [Mutations.SET_IS_MOBILE](state, isMobile) {
            state.isMobile = isMobile;
        }
    },

    actions: {
        mobileView: ({ commit }) => {
            commit(Mutations.SET_IS_MOBILE, true);
        },

        desktopView: async ({ commit, dispatch }) => {
            commit(Mutations.SET_IS_MOBILE, false);
            await dispatch('closeModal');
        }
    }
});


// WEBPACK FOOTER //
// ./src/store/store.js